import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import Link from '../Link';
import * as S from '../styled';

type Item = {
  id?: number;
  link: string;
  icon?: string;
  name: string;
  level?: number;
  additionalPaths: string[];
};

type Props = {
  isFolder: boolean;
  badge: string;
  currentPath: string;
  children: Item[];
} & Item;

const SidebarItem = ({
  id,
  link,
  icon,
  name,
  level,
  badge,
  isFolder,
  children,
  currentPath,
  additionalPaths,
  ...rest
}: Props) => {
  const [isOpen, setOpen] = useState(false);

  const basePath = isFolder ? `${link}_folder` : link;
  const to = `/${basePath}${id ? `/${id}` : ''}`;

  const selected = currentPath && ((
    currentPath.indexOf(link) === 1
  ) || (
    additionalPaths && additionalPaths.includes(
      currentPath.split('/')[1],
    )
    && currentPath.indexOf('/me/') === -1
  ));

  return (
    <Flex
      column
      width="100%"
      shrink="0"
      {...rest}
    >
      <Link
        to={to}
        icon={icon}
        name={name}
        link={link}
        level={level}
        badge={badge}
        isOpen={isOpen}
        isFolder={isFolder}
        selected={selected}
        setOpen={setOpen}
        items={children}
      />

      {isOpen && (
        <S.Sub
          isOpen={isOpen}
          showLine={isFolder && level > 0}
          leftLine={`${level > 1 ? (level * 35) - 21 : 21}px`}
        >
          {children.map(item => (
            <SidebarItem
              key={item.id || item.link}
              link={item.link || link}
              level={level + 1}
              icon={icon}
              {...item}
            />
          ))}
        </S.Sub>
      )}
    </Flex>
  );
};

SidebarItem.defaultProps = {
  id: null,
  icon: null,
  level: 0,
};

export default SidebarItem;
